import { Layout } from '@/components/Layout';
import { LoginView } from '@/features/auth';

export default function Home() {
  return (
    <Layout isLogin>
      <LoginView />
    </Layout>
  );
}
